import React from 'react';

/**
 * Button component with loading state and variants
 * @param {Object} props
 * @param {'primary' | 'outline' | 'ghost' | 'destructive'} props.variant
 * @param {boolean} props.loading
 * @param {boolean} props.fullWidth
 * @param {boolean} props.disabled
 * @param {React.ReactNode} props.children
 * @param {string} props.className
 */
export const Button = ({
  variant = 'primary',
  loading = false,
  fullWidth = false,
  disabled = false,
  children,
  className = '',
  ...props
}) => {
  const baseStyles = 'inline-flex items-center justify-center px-4 py-2 rounded-xl font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-brand-gold300 focus:ring-offset-2 focus:ring-offset-brand-bg disabled:opacity-50 disabled:cursor-not-allowed';
  
  const variants = {
    primary: 'bg-brand-gold text-black hover:bg-brand-gold600 shadow-soft',
    outline: 'border border-brand-gold text-brand-gold hover:bg-brand-gold/10',
    ghost: 'text-brand-gold hover:bg-brand-gold/10',
    destructive: 'bg-red-600 text-white hover:bg-red-700'
  };

  const widthClass = fullWidth ? 'w-full' : '';

  return (
    <button
      className={`${baseStyles} ${variants[variant]} ${widthClass} ${className}`}
      disabled={disabled || loading}
      {...props}
    >
      {loading && (
        <svg 
          className="animate-spin -ml-1 mr-2 h-4 w-4" 
          xmlns="http://www.w3.org/2000/svg" 
          fill="none" 
          viewBox="0 0 24 24"
          aria-label="Loading"
        >
          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
      )}
      {children}
    </button>
  );
};
